import { useEffect } from 'react'
import { applyTheme } from './useTheme.js'

// Optional auto-cycler: Pastel 06-12, Hunter 12-20, Mono 20-06.
// Only kicks in when enabled — explicit profile.theme always wins on first load.

export function useTimeOfDayTheme(enabled) {
  useEffect(() => {
    if (!enabled) return
    function tick() {
      const h = new Date().getHours()
      if (h >= 6 && h < 12) applyTheme('pastel')
      else if (h >= 12 && h < 20) applyTheme('hunter')
      else applyTheme('mono')
    }
    tick()
    const id = setInterval(tick, 1000 * 60 * 15)   // every 15 min
    return () => clearInterval(id)
  }, [enabled])
}
